if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // LOFTY TCG — límite por persona
      // Solo producto sellado (type termina en 'Sealed') con precio > $1,200.00 MXN: máximo 1 unidad
      // Singles: sin límite, cualquier precio
      get loftyLimitThresholdCents() {
        return 120000;
      }

      get loftyMaxQty() {
        return 1;
      }

      get loftyProductPriceCents() {
        const price = parseInt(this.dataset.productPriceCents, 10);
        return isNaN(price) ? 0 : price;
      }

      get loftyIsSealed() {
        return this.dataset.loftySealed === 'true';
      }

      get loftyRequiresLimit() {
        return this.loftyIsSealed && this.loftyProductPriceCents > this.loftyLimitThresholdCents;
      }

      async loftyQtyInCart(variantId) {
        try {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
          });
          const cart = await response.json();
          const variantInCart = cart.items.find((item) => String(item.variant_id) === String(variantId));
          return variantInCart ? variantInCart.quantity : 0;
        } catch (e) {
          console.error('Lofty limit check error:', e);
          return 0;
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const formData = new FormData(this.form);

        // LOFTY TCG — límite 1 unidad SOLO si producto > $1,200 MXN
        if (this.loftyRequiresLimit) {
          const variantId = this.variantIdInput.value;
          const inCart = await this.loftyQtyInCart(variantId);
          const remaining = this.loftyMaxQty - inCart;
          if (remaining <= 0) {
            this.handleErrorMessage('Ya tienes este producto en tu carrito. Límite: 1 unidad por persona (sellado arriba de $1,200 MXN).');
            return;
          }
          let requested = parseInt(formData.get('quantity'), 10);
          if (isNaN(requested) || requested < 1) requested = 1;
          formData.set('quantity', String(Math.min(requested, remaining)));
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
